export class StoresSearchRequest{
    searchTerm: string = '';
    dataSourceId?: string | null = null;
    constructor(searchTerm: string, dataSourceId: string | null = null){
        this.searchTerm = searchTerm;
        this.dataSourceId = dataSourceId;
    }
}